import { Form } from 'antd';
import Box from 'components/Box';
import React from 'react';
import styled from 'styled-components';
import { CustomerBox, CustomerSearchInput, TransactionsList } from './Customer';
import { InputNote } from './Note';
import { IQuickBookingV2CustomerItem, IQuickBookingV2ServiceItem } from './type';
import { ICustomerItemData } from 'services/shop/types/customer';
import toast from 'utils/toast';
const QuickBookingCustomerContent = () => {
  const form = Form.useFormInstance();
  const handleValidateChooseCustomer = (newData: ICustomerItemData) => {
    const customerList: IQuickBookingV2CustomerItem[] = form.getFieldValue('customerList');
    if (customerList.find(o => o.customer?.id === newData?.id)) {
      toast.error('exist customer');
      return false;
    }
    return true;
  };

  const handleChangeCustomer = (data: ICustomerItemData | null) => {
    const customerList: IQuickBookingV2CustomerItem[] = form.getFieldValue('customerList');
    if (customerList.find(o => o.customer?.id === data?.id)) {
      return toast.error('exist customer');
    }

    const masterCustomerId = form.getFieldValue('masterCustomerId');

    if (customerList?.length > 0) {
      const temp = [...customerList];
      if (!masterCustomerId) {
        temp[0] = {
          ...temp[0],
          customer: data || null,
          id: data?.id || '',
          services: temp[0].services.map(service => ({
            ...service,
            customerId: data?.id || '',
          })),
        };
        form.setFieldValue('customerList', temp);
        form.setFieldValue('masterCustomerId', data?.id || '');
        return;
      }

      const masterIdx = temp.findIndex(o => o.customer?.id === masterCustomerId);
      if (masterIdx === -1) return;
      if (!temp[masterIdx]) return;
      temp[masterIdx] = {
        ...temp[masterIdx],
        customer: data || null,
        id: data?.id || '',
        services: temp[masterIdx].services.map(service => ({
          ...service,
          customerId: data?.id || '',
        })),
      };
      form.setFieldValue('customerList', temp);
      form.setFieldValue('masterCustomerId', data?.id || '');
    }
  };

  return (
    <Container display='flex' flexDirection='column'>
      <Content display='flex' flexDirection='column' gap='2'>
        <Form.Item
          noStyle
          name={'customer'}
          rules={[
            ({ getFieldValue }) => ({
              async validator() {
                const customer: IQuickBookingV2ServiceItem[] =
                  getFieldValue('customer');
                if (!customer) {
                  // toast.error('Please choose customer');
                  return Promise.reject('Please choose customer');
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <CustomerSearchInput
            v2NewApt
            preventUnknown
            autoOpenAddWhenNotFound
            v2
            onChange={handleChangeCustomer}
            validate={handleValidateChooseCustomer}
          />
        </Form.Item>
        <Form.Item noStyle name={'masterCustomerId'} />
        <Form.Item noStyle name={'customer'}>
          <CustomerBox />
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => {
            const customer = getFieldValue('customer');
            return customer?.id ? (
              <TransactionsList customerId={customer.id} />
            ) : null;
          }}
        </Form.Item>
      </Content>
      <InputNote />
    </Container>
  );
};

export default QuickBookingCustomerContent;

const Container = styled(Box)`
  flex: 1;
  width: 550px;
  background: #F6F7FC;
`;

const Content = styled(Box)`
  flex: 1;
  height: calc(100% - 100px);
  overflow: auto;
  padding-bottom: 16px;
`;